export const SESSION_STORAGE_HOME_ROUTE_INFO_KEY = '__tradeUpOneOnline_homePageRouteInfo__'
